export default "__VITE_ASSET__8a9ce7b0__"